var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXmlDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10338 3H13.2501H13.7262L14.0628 3.33654L18.7162 7.99L19.0527 8.32654V8.80263V18.3964C19.0527 20.1076 17.6606 21.5 15.9491 21.5H7.10338C5.39185 21.5 3.99976 20.1076 3.99976 18.3964V6.10366C3.99976 4.39212 5.39188 3 7.10338 3ZM5.14918 18.3963C5.14918 19.4759 6.0241 20.3508 7.10338 20.3508H15.9491C17.0287 20.3508 17.9036 19.4759 17.9036 18.3963V8.80259H14.8786C13.9795 8.80259 13.2501 8.07351 13.2501 7.17409V4.14917H7.10342C6.02413 4.14917 5.14921 5.02408 5.14921 6.10366L5.14918 18.3963Z",
    fill: "#4B5563"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 17,
    height: 6,
    rx: 2,
    fill: "#4B5563"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84668 12.9502L6.86133 12.9717L7.79883 14.3408L8.75098 12.9717L8.76562 12.9502H9.51367L9.45801 13.0283L8.16113 14.8721L9.60254 16.9717L9.65625 17.0498H8.85156L8.83691 17.0283L7.75488 15.4551L6.66016 17.0283L6.64453 17.0498H5.9043L5.95898 16.9717L7.38477 14.916L6.08789 13.0283L6.03418 12.9502H6.84668ZM15.208 12.9502V16.4805H17.0498V17.0498H14.5186V12.9502H15.208ZM10.5752 17.0498H9.9502V12.9502H10.9219L10.9326 12.9854L11.7314 15.6074L11.7861 15.8281C11.8031 15.9118 11.8195 16.0055 11.834 16.1094L11.8496 16.2217C11.8544 16.1854 11.8585 16.1463 11.8643 16.1045C11.8932 15.8918 11.927 15.7251 11.9668 15.6064L12.7656 12.9854L12.7764 12.9502H13.748V17.0498H13.0654V14.0898C13.0681 14.0329 13.072 13.972 13.0762 13.9072C13.06 13.9787 13.0457 14.0461 13.0264 14.1074L12.1201 17.0146L12.1084 17.0498H11.5244L11.5137 17.0146L10.5996 14.1074V14.1064C10.5895 14.0736 10.5795 14.0348 10.5684 13.9902C10.5704 14.0249 10.5736 14.0582 10.5752 14.0898V17.0498Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlDownload);
export default __webpack_public_path__ + "static/media/xml-download.7d2ae8d16076844f19f6e0710be1f7a3.svg";
export { ForwardRef as ReactComponent };